<template>
  <div class="jumpwxapp">
    <!-- JUMP WXAPP -->
    <a class="button" :href="link">立即添加班主任</a>
  </div>
</template>

<script>
import sasdk from './sasdkinit'
export default {
  data () {
    return {
      link: ''
    }
  },
  computed: {
    isMobile () {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|IEMobile)/i)
    },
    isWeixin () {
      const ua = navigator.userAgent.toLowerCase()
      const isWXWork = ua.match(/wxwork/i) === 'wxwork'
      const m = ua.match(/MicroMessenger/i)
      return !isWXWork && m && m[0] === 'micromessenger'
    }
  },
  mounted () {
    sasdk.viewJumpwxApp()
    const ticket = this.$route.query.t
    this.link = `weixin://dl/business/?t=${ticket}`
    if (ticket && this.isMobile && !this.isWeixin) {
      window.location.href = `weixin://dl/business/?t=${ticket}`
    } else {
    }
  }
}
</script>

<style lang="scss" scoped>
  .jumpwxapp {
    background: url('~@/assets/img/jump/centerbg.png') center top;
    width: 100%;
    height: 100vh;
    background-size: cover;
    position: relative;
    .button {
      width: 443px;
      height: 80px;
      line-height: 80px;
      margin: 0 auto;
      background: #ff6421;
      border-radius: 80px;
      color: #fff;
      font-size: 34px;
      text-align: center;
      display: block;
      position: absolute;
      bottom: 626px;
      left: 50%;
      margin-left: -222px;
    }
  }

</style>
